import React from 'react';
import './GestionRessources.css';
import DashboardHeader from '../components/DashboardHeader';
import AdminNavigationBar from '../components/AdminNavigationBar';
import { FoodIcon } from '../components/Icons';

function GestionRessources() {
  const transactions = [
    {
      id: 1,
      envoyePar: 'Tesco Market',
      avatar: '🛒',
      type: 'Scolarité',
      date: '13 Dec 2020',
      montant: '23000'
    },
    {
      id: 2,
      envoyePar: 'ElectroMen Market',
      avatar: '⚡',
      type: 'Carte scolaire',
      date: '14 Dec 2020',
      montant: '45678'
    },
    {
      id: 3,
      envoyePar: 'Fiorgio Restaurant',
      avatar: <FoodIcon size={24} color="#FF6B35" />,
      type: 'Scolarité',
      date: '07 Dec 2020',
      montant: '769000'
    },
    {
      id: 4,
      envoyePar: 'John Mathew Kayne',
      avatar: '👤',
      type: 'Sport',
      date: '06 Dec 2020',
      montant: '900876'
    },
    {
      id: 5,
      envoyePar: 'Ann Martin',
      avatar: '👩',
      type: 'T-shirt',
      date: '31 Nov 2020',
      montant: '15678'
    }
  ];

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Gestion des Ressources" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="ressources-content">
            <div className="ressources-grid">
              {/* Total Revenue Chart */}
              <div className="revenue-chart-card">
                <div className="chart-header">
                  <h3>Total Revenue</h3>
                  <div className="chart-legend">
                    <span className="legend-item">
                      <span className="legend-dot revenu"></span>
                      Revenu
                    </span>
                    <span className="legend-item">
                      <span className="legend-dot depense"></span>
                      Dépense
                    </span>
                  </div>
                </div>
                
                <div className="chart-container">
                  <svg viewBox="0 0 800 300" className="revenue-chart">
                    {/* Y-axis labels */}
                    <text x="30" y="30" className="axis-label">40k</text>
                    <text x="30" y="90" className="axis-label">30k</text>
                    <text x="30" y="150" className="axis-label">20k</text>
                    <text x="30" y="210" className="axis-label">10k</text>
                    <text x="30" y="270" className="axis-label">0</text>
                    
                    {/* X-axis labels */}
                    <text x="80" y="295" className="axis-label">Janv</text>
                    <text x="140" y="295" className="axis-label">Fev</text>
                    <text x="200" y="295" className="axis-label">Mars</text>
                    <text x="260" y="295" className="axis-label">Avr</text>
                    <text x="320" y="295" className="axis-label">Mai</text>
                    <text x="380" y="295" className="axis-label">Juin</text>
                    <text x="440" y="295" className="axis-label">Juil</text>
                    <text x="500" y="295" className="axis-label">Aout</text>
                    <text x="560" y="295" className="axis-label">Sept</text>
                    <text x="620" y="295" className="axis-label">Oct</text>
                    <text x="680" y="295" className="axis-label">Nov</text>
                    <text x="740" y="295" className="axis-label">Déc</text>
                    
                    {/* Revenue line (blue) */}
                    <path d="M 80 180 Q 140 120, 200 140 T 320 80 T 440 160 T 560 180 T 680 200 T 760 210" 
                          stroke="#0078D7" strokeWidth="3" fill="none" className="chart-line"/>
                    
                    {/* Expense line (red) */}
                    <path d="M 80 140 Q 140 100, 200 120 T 320 60 T 440 140 T 560 100 T 680 80 T 760 120" 
                          stroke="#FF6B6B" strokeWidth="3" fill="none" className="chart-line"/>
                    
                    {/* Vertical dashed line at Juin */}
                    <line x1="380" y1="30" x2="380" y2="270" stroke="#ddd" strokeWidth="2" strokeDasharray="5,5"/>
                    
                    {/* Data point at Juin */}
                    <circle cx="380" cy="80" r="5" fill="#0078D7"/>
                    <rect x="360" y="50" width="80" height="25" fill="#E3F2FD" rx="4"/>
                    <text x="400" y="68" className="data-label" textAnchor="middle">3,879,300</text>
                    
                    {/* Data point at Oct */}
                    <circle cx="620" cy="100" r="5" fill="#FF6B6B"/>
                    <rect x="600" y="70" width="80" height="25" fill="#FFE5E5" rx="4"/>
                    <text x="640" y="88" className="data-label-red" textAnchor="middle">1,526,700</text>
                  </svg>
                </div>
              </div>

              {/* October 2024 Donut Chart */}
              <div className="donut-chart-card">
                <h3>Octobre 2024</h3>
                <div className="donut-container">
                  <svg viewBox="0 0 200 200" className="donut-chart">
                    <circle cx="100" cy="100" r="80" fill="none" stroke="#FF6B6B" strokeWidth="40" 
                            strokeDasharray="314 314" transform="rotate(-90 100 100)"/>
                    <circle cx="100" cy="100" r="80" fill="none" stroke="#0078D7" strokeWidth="40" 
                            strokeDasharray="195 314" strokeDashoffset="0" transform="rotate(-90 100 100)"/>
                    <text x="100" y="105" className="donut-percentage" textAnchor="middle">62%</text>
                  </svg>
                  <p className="donut-label">Total Revenu</p>
                </div>
                <div className="donut-legend">
                  <div className="donut-legend-item">
                    <span className="donut-legend-box revenu"></span>
                    <span>Revenue</span>
                  </div>
                  <div className="donut-legend-item">
                    <span className="donut-legend-box depense"></span>
                    <span>Dépense</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Section */}
            <div className="ressources-bottom-grid">
              {/* Historique des Transactions */}
              <div className="transactions-card">
                <div className="transactions-header">
                  <h3>Historique des Transactions</h3>
                  <button className="voir-plus-btn">Voir plus</button>
                </div>
                
                <table className="transactions-table">
                  <thead>
                    <tr>
                      <th>Envoyé par :</th>
                      <th>Type</th>
                      <th>Date</th>
                      <th>Montant</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((transaction) => (
                      <tr key={transaction.id}>
                        <td>
                          <div className="sender-info">
                            <div className="sender-avatar">{transaction.avatar}</div>
                            <span>{transaction.envoyePar}</span>
                          </div>
                        </td>
                        <td>{transaction.type}</td>
                        <td>{transaction.date}</td>
                        <td className="montant">{transaction.montant}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Evolution du taux de payement */}
              <div className="evolution-card">
                <h3>Evolution du taux de payement</h3>
                <div className="evolution-stats">
                  <p className="evolution-label">Total des élèves</p>
                  <p className="evolution-value">134 ont soldés</p>
                </div>
                <div className="evolution-chart">
                  <svg viewBox="0 0 400 200" className="area-chart">
                    {/* Y-axis labels */}
                    <text x="10" y="30" className="axis-label-small">500</text>
                    <text x="10" y="90" className="axis-label-small">300</text>
                    <text x="10" y="150" className="axis-label-small">100</text>
                    
                    {/* X-axis labels */}
                    <text x="80" y="195" className="axis-label-small">Janv</text>
                    <text x="180" y="195" className="axis-label-small">Mars</text>
                    <text x="280" y="195" className="axis-label-small">Mai</text>
                    
                    {/* Area chart */}
                    <path d="M 50 120 L 100 100 L 150 110 L 200 90 L 250 100 L 300 80 L 350 90 L 350 180 L 50 180 Z" 
                          fill="url(#blueGradient)" opacity="0.6"/>
                    <path d="M 50 120 L 100 100 L 150 110 L 200 90 L 250 100 L 300 80 L 350 90" 
                          stroke="#0078D7" strokeWidth="3" fill="none"/>
                    
                    <defs>
                      <linearGradient id="blueGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#0078D7" stopOpacity="0.4"/>
                        <stop offset="100%" stopColor="#0078D7" stopOpacity="0.05"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <button className="telecharger-rapport-btn">Télécharger un rapport</button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default GestionRessources;
